import React, { useEffect, useState, forwardRef } from 'react';
import clsx from 'clsx';
import { icons } from '/react4xp/components/Svg/Icons/IconList';

interface SearchInputProps {
    bgColor?: 'transparent' | 'primary' | 'white' | string;
    color?: 'primary' | 'secondary' | 'light';
    href?: string;
    target?: boolean;
    type?: 'button';
    className?: string;
    children?: React.ReactNode;
    onClick?: () => void;
    leftIcon?: string;
    rightIcon?: string;
    size?: 'xs' | 'sm' | 'md' | 'lg';
    placeholder?: string;
}

const SearchInput = forwardRef<HTMLInputElement, SearchInputProps>(({
    bgColor = 'transparent',
    color = 'primary',
    href,
    target,
    type = 'button',
    className,
    children,
    onClick,
    leftIcon,
    rightIcon,
    size = 'md',
    placeholder = 'Search',
}, ref) => {
    const [currentPlaceholder, setCurrentPlaceholder] = useState(placeholder);
    const [inputValue, setInputValue] = useState('');

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth <= 768) { // Adjust the breakpoint as needed
                setCurrentPlaceholder('Search');
            } else {
                setCurrentPlaceholder(placeholder);
            }
        };

        handleResize(); // Set initial placeholder
        window.addEventListener('resize', handleResize); // Update on resize

        return () => {
            window.removeEventListener('resize', handleResize); // Clean up event listener
        };
    }, [placeholder]);

    const elementProps = {
        href: href || null,
        target: target ? '_blank' : undefined,
        onClick: onClick,
        className: clsx(
            'search-input',
            className
        )
    }

    let LeftIcon, RightIcon

    if (leftIcon) {
        const foundIcon = icons.find(icon => icon.name === leftIcon);
        LeftIcon = foundIcon ? foundIcon.component : null;
    }
    if (rightIcon) {
        const foundIcon = icons.find(icon => icon.name === rightIcon);
        RightIcon = foundIcon ? foundIcon.component : null;
    }

    function handleSubmit(e) {
        e?.preventDefault()

        if (href && inputValue) {
            const encodedInput = encodeURIComponent(inputValue)
            const searchPageUrl = new URL(href)
            
            searchPageUrl.searchParams.set('search', encodedInput)
            window.location.href = searchPageUrl.toString()
        }

    }

    return (
        <form {...elementProps} onSubmit={handleSubmit}>

            {LeftIcon && (
                <div className="search-input__left-icon">
                    <LeftIcon className="search-input__left-icon" />
                </div>
            )}

            <label>

                <span className='visually-hidden'>
                    {currentPlaceholder}
                </span>

                <input
                    ref={ref}
                    type='search'
                    className='search-input__field'
                    placeholder={currentPlaceholder}
                    onChange={(e) => setInputValue(e.target.value)}
                    value={inputValue}
                    id="header-search-input"
                />

            </label>

            {RightIcon && (
                <button type='submit' onClick={handleSubmit} className="search-input__right-icon">
                    <RightIcon />
                </button>
            )}

        </form>
    )
})

export default SearchInput;
